module.exports = __webpack_public_path__ + "0a888d5d532bb39fafc8d10b3537729d.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/logos/brand-logo-coca-cola.png
// module id = 629
// module chunks = 0